// Positions the compact header dropdowns (Our Process, Help Center) directly
// under their trigger link.
//
// The dropdown's visible box lives inside a FULL-WIDTH submenu layer (same
// containing block as the mega menu: the header row). That layer spans the
// viewport exactly and can never overflow, so it can't trigger the
// overflow-list's resize/reflow loop. This script only slides the small box
// horizontally inside that layer via the --compact-left custom property; the
// CSS clamps it so the box always stays on-screen.

(function () {
  if (window.__compactMenuInit) return;
  window.__compactMenuInit = true;

  function position(submenu) {
    var box = submenu.querySelector('.compact-menu');
    var inner = submenu.querySelector('.menu-list__submenu-inner');
    var item = submenu.closest('.menu-list__list-item');
    var trigger = item && item.querySelector('.menu-list__link');
    if (!box || !inner || !trigger) return;

    var left = trigger.getBoundingClientRect().left - inner.getBoundingClientRect().left;
    box.style.setProperty('--compact-left', Math.max(0, left) + 'px');
  }

  function positionAll() {
    document.querySelectorAll('.menu-list__submenu--compact').forEach(position);
  }

  // Recompute the moment a menu item is hovered, so the position is always
  // current even after the menu re-flows or re-hydrates.
  document.addEventListener('pointerover', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var item = target.closest('.menu-list__list-item');
    if (!item) return;
    var submenu = item.querySelector('.menu-list__submenu--compact');
    if (submenu) position(submenu);
  });

  window.addEventListener('resize', positionAll);
  window.addEventListener('load', positionAll);
  if (document.readyState !== 'loading') positionAll();
})();
